<template>
	<div class="rich-text-editor">
		<div class="rich-text-editor__toolbar">
			<v-btn
				v-for="button in toolbarButtons"
				:key="button.command"
				icon
				small
				:title="button.title"
				@click.prevent="format(button.command, button.value)"
			>
				<v-icon small>{{ button.icon }}</v-icon>
			</v-btn>
			<v-divider vertical class="mx-1"></v-divider>
			<v-btn icon small title="Link toevoegen" @click.prevent="addLink">
				<v-icon small>mdi-link</v-icon>
			</v-btn>
			<v-btn icon small title="Opmaak verwijderen" @click.prevent="format('removeFormat')">
				<v-icon small>mdi-format-clear</v-icon>
			</v-btn>
		</div>
		<div
			ref="editor"
			class="rich-text-editor__content"
			contenteditable="true"
			:data-placeholder="placeholder"
			@input="emitContent"
			@blur="emitContent"
			@paste="pastePlainText"
		></div>
	</div>
</template>

<script>
export default {
	name: "RichTextEditor",
	props: {
		value: {
			type: String,
			default: ""
		},
		placeholder: {
			type: String,
			default: "Voer informatie in..."
		}
	},
	data() {
		return {
			toolbarButtons: [
				{ command: "bold", icon: "mdi-format-bold", title: "Vet" },
				{ command: "italic", icon: "mdi-format-italic", title: "Cursief" },
				{ command: "underline", icon: "mdi-format-underline", title: "Onderstrepen" },
				{
					command: "insertUnorderedList",
					icon: "mdi-format-list-bulleted",
					title: "Opsomming"
				},
				{
					command: "insertOrderedList",
					icon: "mdi-format-list-numbered",
					title: "Genummerde lijst"
				}
			]
		};
	},
	watch: {
		value: {
			immediate: true,
			handler(value) {
				this.$nextTick(function() {
					if (
						this.$refs.editor &&
						this.$refs.editor.innerHTML !== (value || "")
					) {
						this.$refs.editor.innerHTML = value || "";
					}
				});
			}
		}
	},
	methods: {
		format(command, value) {
			this.$refs.editor.focus();
			document.execCommand(command, false, value || null);
			this.emitContent();
		},
		addLink() {
			var url = window.prompt("Voer de URL in:");
			if (!url) return;
			var normalized = /^https?:\/\//i.test(url) ? url : "https://" + url;
			this.format("createLink", normalized);
		},
		pastePlainText(event) {
			event.preventDefault();
			var text = (event.clipboardData || window.clipboardData).getData("text");
			document.execCommand("insertText", false, text);
		},
		emitContent() {
			var html = this.$refs.editor ? this.$refs.editor.innerHTML : "";
			if (html === "<br>") html = "";
			this.$emit("input", html);
		}
	}
};
</script>

<style scoped>
.rich-text-editor {
	border: 1px solid rgba(0, 0, 0, 0.28);
	border-radius: 4px;
	background: rgba(0, 0, 0, 0.04);
}
.rich-text-editor__toolbar {
	display: flex;
	align-items: center;
	min-height: 40px;
	padding: 2px 6px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.18);
	background: #fff;
}
.rich-text-editor__content {
	min-height: 180px;
	max-height: 420px;
	overflow-y: auto;
	padding: 12px;
	background: #fff;
	outline: none;
	line-height: 1.5;
}
.rich-text-editor__content:empty::before {
	content: attr(data-placeholder);
	color: rgba(0, 0, 0, 0.45);
	pointer-events: none;
}
</style>
